import { Stack } from "@mui/material"
import { ReactElement, useState } from "react"

import DashboardPanelFrame from "../../components/dashboard/dashboardPanelFrame"
import ReleaseSnackbar from "../../components/snackbar/releaseSnackbar"
import { DISPLAY_ROLES, INSTALLER } from "../../constants/roles"
import { useGetUserData } from "../../hooks/useGetUserData"
import { GRID_SPACING } from "../../themes/defaultThemeParams"

/**
 * Renders the homepage for Installers
 *
 */
const InstallerHomepage = (): ReactElement => {
    const { firstName } = useGetUserData()
    const [open, setOpen] = useState(true)

    return (
        <Stack
            direction={{ xs: "column", md: "column" }}
            spacing={GRID_SPACING}
            alignItems="stretch"
        >
            <Stack>
                <DashboardPanelFrame
                    userName={firstName}
                    permission={DISPLAY_ROLES[INSTALLER]}
                />
            </Stack>
            {/* <ReleaseSnackbar open={open} setOpen={setOpen} /> */}
        </Stack>
    )
}

export default InstallerHomepage
